export default __webpack_public_path__ + "static/media/arrow-right.f6e09b99.svg";